var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17Zm0-1a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.802 14.51a.5.5 0 0 1 .708-.708l9.344 9.344a.5.5 0 0 1-.708.708l-9.344-9.344Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.2307d3e43c3899800d7daa6bd44faaa5.svg";